/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Suspended_ToastInputs */

const cs_franchise_suspended_toast = /** @type {(inputs: Franchise_Suspended_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence pozastavena`)
};

const en_franchise_suspended_toast = /** @type {(inputs: Franchise_Suspended_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License suspended`)
};

/**
* | output |
* | --- |
* | "License suspended" |
*
* @param {Franchise_Suspended_ToastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_suspended_toast = /** @type {((inputs?: Franchise_Suspended_ToastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Suspended_ToastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_suspended_toast(inputs)
	return cs_franchise_suspended_toast(inputs)
});